import React from 'react';
import { Grid, Chip, Typography } from '@material-ui/core/';
import CurrencyIcon from '../global/currency/CurrencyIcon';
import { axiosInstance } from '../../util/axiosInstance';


class AdditionalDiscount extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            //haveAdditionalDiscount: false,
        }
    }

    async componentDidMount() {
        //const isFirstOrderResponse = await axiosInstance.get(`api/Payment/IsFirstOrder`);

        //this.setState({
        //    haveAdditionalDiscount: isFirstOrderResponse.data,
        //});
    }

    render() {

        const haveAdditionalDiscount = this.props.haveAdditionalDiscount;
        const discount = this.props.discount;

        if (haveAdditionalDiscount) {

            return (
                <div>

                    <br />

                    <Grid container spacing={1}>
                        <Grid item xs={7}>
                            <h5 style={{ color: '#0074bc', fontSize: '1.0rem', float: 'left' }}>
                                Su pago final
                                                    </h5>
                        </Grid>
                        <Grid item xs={5}>
                            <h5 style={{ color: '#0074bc', fontSize: '1.0rem', float: 'right', fontWeight: '500', textDecoration: 'line-through' }}>
                                <CurrencyIcon /> {this.props.totalPrice}
                            </h5>
                        </Grid>
                    </Grid>

                    <br />



                    <Grid container spacing={1}
                        justify="space-between"
                        alignItems="center">
                        <Grid item>
                            <Chip className="w-100" style={{ backgroundColor: '#e43e6e', color: '#FFF' }} label={discount + "% OFF"} />
                        </Grid>
                        <Grid item>
                            <Typography style={{ color: '#e43e6e', fontSize: '1.3rem', fontWeight: '800' }}>
                                <CurrencyIcon /> {this.props.totalPriceFirstOrder}
                            </Typography>
                        </Grid>
                    </Grid>

                </div>
            );
        }
        else {
            return (
                <Grid container spacing={1}>
                    <Grid item xs={7}>
                        <h5 style={{ color: '#0074bc', fontSize: '1.0rem', float: 'left' }}>
                            Su pago final
                                                    </h5>
                    </Grid>
                    <Grid item xs={5}>
                        <h5 style={{ color: '#0074bc', fontSize: '1.0rem', float: 'right', fontWeight: '500' }}>
                            <CurrencyIcon /> {this.props.totalPrice}
                        </h5>
                    </Grid>
                </Grid>);
		}
    };
}

export default AdditionalDiscount;